<template>
  <div class="online-for">
    <div class="online-for__row">
      <span class="online-for__row__label">{{ t("description") }}</span>

      <v-text-field :value="onlineForLabel" :disabled="disabled" readonly hide-details />

      <span :class="['online-for__row__label', 'online-for__row__label--faded']">
        {{ t("uptime") }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { createTranslationModule } from "@/plugins/i18n"
import Utils from "@/utils/utils"
import { defineComponent, computed } from "@vue/composition-api"

export default defineComponent({
  name: "OnlineFor",
  props: {
    start: {
      type: Number,
      required: true
    },
    end: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const t = createTranslationModule("AutoShutdown.onlineFor")

    const onlineForTime = computed(() => {
      return Utils.dateRange(props.start, props.end)
    })

    const onlineForLabel = computed(() => {
      const { days, hours, min } = onlineForTime.value

      if (days > 0) {
        return `${days} ${t("day", undefined, days)}`
      } else {
        if (hours > 0) {
          return `${hours}h ${min}min`
        } else {
          return `${min}min`
        }
      }
    })

    return {
      t,
      onlineForLabel
    }
  }
})
</script>
